import styled from 'styled-components';

const ListStyles = styled.div`
	.listProduct {
		margin: 20px 0px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
`;
export default ListStyles;
